import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchPlatformBidCharges = async (params = {}) => {
  try {
    let qs = reqTransform.fetchPlatformCharges(params);
    const url = `${baseUrl}/BioFuelRequirementOffers/api/Bid/FetchPlatformCharges?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchPlatformCharges(resData);
  } catch (err) {
    console.log('api-affiliates-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchPlatformCharges');
    throw errors;
  }
};

export const fetchPlatformOfferCharges = async (params = {}) => {
  try {
    let qs = reqTransform.fetchPlatformCharges(params);
    const url = `${baseUrl}/BioFuelRequirementOffers/api/Offer/FetchPlatformCharges?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchPlatformCharges(resData);
  } catch (err) {
    console.log('api-affiliates-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchPlatformCharges');
    throw errors;
  }
};

export const fetchPlatformAuctionCharges = async (params = {}) => {
  try {
    let qs = reqTransform.fetchPlatformChargesAuction(params);
    const url = `${baseUrl}/BioFuelAuctions/api/Bid/FetchPlatformCharges?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchPlatformChargesAuction(resData);
  } catch (err) {
    console.log('api-affiliates-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchPlatformCharges');
    throw errors;
  }
};

export const fetchPlatformCommonCharges = async (params = {}) => {
  try {
    let qs = reqTransform.fetchPlatformChargesAuction(params);
    const url = `${baseUrl}/BioFuelCommonUtilities/api/CommonUtilities/FetchPlatformCharges?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchPlatformChargesAuction(resData);
  } catch (err) {
    console.log('api-affiliates-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchPlatformCharges');
    throw errors;
  }
};
